import React, { useEffect, useState } from "react";
import { TableContainer, Paper, Button } from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import ImportExcel from "../../../components/Imports/ImportExcel";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import { Post_To_MongoDB } from "../../../../Public/api/Post_To_MongoDB";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
// material-ui

function ImportTransactions() {
  const { logout } = StaffuseAuth();

  const [Arr_Transactions, setArr_Transactions] = useState([]);

  let Arr_PropsToSee = [
    "Invoice Number",
    "Contact",
    "Invoice Date",
    "Due Date",
    "Last Payment Date",
    "Reference",
    "Gross (GBP)",
    "VAT (GBP)",
    "Balance (GBP)",
    "Status",
    "Source",
    "Career/Team",
  ];

  let Arr_PropsToSee_TemplateExport = [
    {
      "Invoice Number": "Insert",
      Contact: "Insert",
      "Invoice Date": "Insert",
      "Due Date": "Insert",
      "Last Payment Date": "Insert",
      Reference: "Insert",
      "Gross (GBP)": "Insert",
      "VAT (GBP)": "Insert",
      "Balance (GBP)": "Insert",
      Status: "Insert",
      Source: "Insert",
      "Career/Team": "Insert",
    },
  ];

  const [UploadStatus, setUploadStatus] = useState(false);
  console.log("Arr_Transactions");
  console.log(Arr_Transactions);

  function ConvertDate(serialDate) {
    // Check if serialDate is undefined or null
    if (serialDate == null) {
      return `01-01-2000`;
    }

    // Convert serialDate to a number if it's a string
    const serialNumber = Number(serialDate);

    // Check if the conversion was successful and if the number is valid
    if (isNaN(serialNumber) || serialNumber <= 0) {
      return `01-01-2000`;
    }

    const baseDate = new Date(1900, 0, 1); // January 1, 1900
    const daysOffset = serialNumber - 1; // Excel serial dates start from 1
    const convertedDate = new Date(
      baseDate.setDate(baseDate.getDate() + daysOffset)
    );

    const day = String(convertedDate.getDate()).padStart(2, "0");
    const month = String(convertedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = convertedDate.getFullYear();

    return `${year}-${month}-${day}`;
  }

  function handleUploadData(e) {
    let updatedArr_Transactions = [...Arr_Transactions];
    //change all prop titles of Invoice Date to Invoice_Date in updatedArr_Transactions
    updatedArr_Transactions.forEach((transaction) => {
      //
      transaction.Invoice_Date = ConvertDate(transaction["Invoice Date"]);
      delete transaction["Invoice Date"];
      //
      transaction.Invoice_Number = transaction["Invoice Number"];
      delete transaction["Invoice Number"];
      //
      transaction.Due_Date = ConvertDate(transaction["Due Date"]);
      delete transaction["Due Date"];
      //
      transaction.Last_Payment_Date = ConvertDate(
        transaction["Last Payment Date"]
      );
      delete transaction["Last Payment Date"];
      //
      transaction.Gross_GBP = transaction["Gross (GBP)"];
      delete transaction["Gross (GBP)"];
      //
      transaction.VAT_GBP = transaction["VAT (GBP)"];
      delete transaction["VAT (GBP)"];
      //
      transaction.Balance_GBP = transaction["Balance (GBP)"];
      delete transaction["Balance (GBP)"];
      //
      transaction.Career_Team = transaction["Career/Team"];
      delete transaction["Career/Team"];
      //
      transaction.Import_Date = new Date().toISOString().split("T")[0];
    });
    //Loop thro Arr_Transactions and uplaod each to mongoDB
    updatedArr_Transactions.forEach((transaction) => {
      Post_To_MongoDB(
        transaction,
        "Invoices",
        "Transactions_2025",
        setUploadStatus,
        logout
      );
    });
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Import Transactions</h1>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <h2>View All Transactions</h2>
          <ImportExcel setImportData={setArr_Transactions} />
          Get Template:
          <DisplayExport
            excelData={Arr_PropsToSee_TemplateExport}
            fileName={"Transactions_Import_Template"}
          />
          <button
            style={{ maxWidth: "5%", maxHeight: "100px" }}
            onClick={(e) => handleUploadData(e)}
          >
            Upload to the Database
          </button>
        </div>

        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {Arr_PropsToSee && Array.isArray(Arr_PropsToSee) ? (
                    Arr_PropsToSee.map((Prop, Prop_index) =>
                      SimpleTableHeader(Prop)
                    )
                  ) : (
                    <></>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ border: "1px solid black" }}></TableRow>

                {Arr_Transactions && Array.isArray(Arr_Transactions) ? (
                  Arr_Transactions.map(
                    (Obj_Transaction, Obj_Transaction_index) => (
                      <>
                        <TableRow
                          key={Obj_Transaction_index}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                              "& .MuiTableCell-root": {
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word", // Adjust padding here to make cells smaller
                              },
                            },
                          }}
                        >
                          {Arr_PropsToSee && Array.isArray(Arr_PropsToSee) ? (
                            Arr_PropsToSee.map((Prop, Prop_index) =>
                              Prop.includes("Date") ? (
                                <TableCell
                                  component="th"
                                  scope="row"
                                  sx={{
                                    padding: "8px",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {Obj_Transaction[Prop]} and{" "}
                                  {ConvertDate(Obj_Transaction[Prop])}
                                </TableCell>
                              ) : (
                                <TableCell
                                  component="th"
                                  scope="row"
                                  sx={{
                                    padding: "8px",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {Obj_Transaction[Prop]}
                                </TableCell>
                              )
                            )
                          ) : (
                            <></>
                          )}
                        </TableRow>
                      </>
                    )
                  )
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
      </section>
    </div>
  );
}

export default ImportTransactions;
